<!--  -->
<template>
  <div>
    <div class="div_title">
      <span>{{poiName}}</span>

      <i
        id="id_i_addcollect"
        title="添加收藏"
        class="collect_icon"
      ></i>

    </div>

    <div class="div_POIAttribute">
      <p v-show="phoneSN">
        <span>电话:</span>
        <span>{{phoneSN}}</span>
      </p>
      <p v-show="address">
        <span>地址:</span>
        <span>{{address}}</span>
      </p>

      <p v-show="remark">
        <span>备注:</span>
        <span>{{remark}}</span>
      </p>
    </div>

    <div>
      <div class="div_surroundType">
        <ul>
          <li
            id="li_surroundType_poi"
            class="focused"
          >
            <i class="i_nearFind"></i>
            <a>在附近找</a>
          </li>

          <li id="li_surroundType_routeStartPOI">
            <i class="i_startPOI"></i>
            <a>设为起点</a>
          </li>

          <li id="li_surroundType_driveViaPOI">
            <i class="i_driveViaPOI"></i>
            <a>经过这里</a>
          </li>

          <li id="li_surroundType_driveEndPOI">
            <i class="i_endPOI"></i>
            <a>设为终点</a>
          </li>

        </ul>
      </div>

      <div class="div_POIType">
        <ul>
          <li
            v-for="item in poiTypes"
            :key="item.id"
            :id="item.id"
          >
            <a>{{item.name}}</a>
          </li>
        </ul>

        <input
          id="inputPOISearch"
          type="text"
        >
        <span id="spanPOISearch">搜索</span>
      </div>

    </div>

  </div>
</template>

<script>
import { POIResultItem } from "../../model/POISearch.js";

export default {
  name: "POISurroundOverLay",
  data() {
    return {
      uc: {
        id_inputPOISearch: "inputPOISearch",
        id_spanPOISearch: "spanPOISearch",
        id_li_surroundType_poi: "li_surroundType_poi",
        id_li_surroundType_routeStartPOI: "li_surroundType_routeStartPOI",
        id_li_surroundType_driveViaPOI: "li_surroundType_driveViaPOI",
        id_li_surroundType_driveEndPOI: "li_surroundType_driveEndPOI",
        id_poiType_school: "poiType_school",
        id_poiType_hospital: "poiType_hospital",
        id_poiType_busStation: "poiType_busStation",
        id_poiType_bank: "poiType_bank"
      },

      curPOI: new POIResultItem(),

      poiName: null,

      phoneSN: null,

      address: null,

      remark: null,

      /**
       * poi类型信息
       */
      poiTypes: [
        {
          id: "poiType_school",
          name: "学校"
        },

        {
          id: "poiType_hospital",
          name: "医院"
        },

        {
          id: "poiType_busStation",
          name: "公交站"
        },

        {
          id: "poiType_bank",
          name: "银行"
        }
      ]
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    init() {
      this.poiName = this.curPOI.name;
      this.phoneSN = this.curPOI.phone;
      this.address = this.curPOI.address;
      this.remark = this.curPOI.remark;
    }
  }
};
</script>
<style lang="scss" scoped>
.i_nearFind {
  // float: left;
  background: url("../../../../assets/onlineMap/icon.png") #fff;
  background-position: -189px -153px;
  width: 17px;
  height: 17px;
  background-repeat: no-repeat;

  display: inline-block;
}

.i_startPOI {
  background: url("../../../../assets/onlineMap/icon.png") #fff;
  background-repeat: no-repeat;
  display: inline-block;
  width: 17px;
  height: 17px;

  background-position: -123px -153px;
}

.i_driveViaPOI {
  display: inline-block;
  width: 17px;
  height: 17px;
  // float: left;
  background: url("../../../../assets/onlineMap/icon.png") #fff;
  background-repeat: no-repeat;
  background-position: -145px -153px;
}

.i_endPOI {
  display: inline-block;
  width: 17px;
  height: 17px;
  // float: left;
  background: url("../../../../assets/onlineMap/icon.png") #fff;
  background-repeat: no-repeat;

  background-position: -167px -153px;
}

.collect_icon {
  background: url("../../../../assets/onlineMap/icon.png");
  background-position: -99px -155px;
  width: 17px;
  height: 16px;
  display: inline-block;
  cursor: pointer;
}

.div_title {
  width: 335px;
  display: flex;
  font-weight: 700;
  font-size: 14px;
  border-bottom: 1px solid #ccc;
  padding: 5px 10px;

  span {
    display: inline-block;
    width: 270px;
    height: 20px;
    overflow: hidden;
    white-space: nowrap;
    // float: left;
  }
}

.div_POIAttribute {
  p {
    margin: 10px 0;
    font-size: 12px;
  }
}

.div_surroundType {
  // height: 62px;

  .focused {
    border: 1px solid #be0106;
  }

  ul {
    padding: 0;
    float: left;
    margin-top: 2px;
    margin-bottom: 0;
    margin: 0;

    li {
      list-style: none;
      float: left;
      padding: 3px 4px;
      border: 1px solid #ccc;
      border-right: 0;
      position: relative;
      cursor: pointer;
      line-height: 0.8;

      a {
        text-decoration: none;
        font-size: 12px;
        color: #0078a8;
      }
    }
  }
}

.div_POIType {
  height: 30px;
  line-height: 30px;

  ul {
    float: left;
    margin-top: 2px;
    margin-bottom: 0;
    padding: 0;
    clear: both;
    content: "";
    display: table;
    list-style: none;
    // padding: 0;
    margin: 0;

    li {
      list-style: none;
      float: left;
      line-height: 28px;
      padding: 0 1px;
      display: list-item;
      // text-align: -webkit-match-parent;

      a {
        text-decoration: none;
        font-size: 12px;
        color: #0078a8;
        cursor: pointer;
      }
    }
  }

  input {
    float: left;
    margin-top: 4px;
    width: 157px;
    height: 23px;
    outline: none;
    border: 1px solid #ccc;
  }

  span {
    margin-top: 4px;
    margin-left: 4px;
    text-align: center;
    width: 47px;
    height: 24px;
    line-height: 24px;
    display: inline-block;
    background: #3385ff;
    color: #fff;
    cursor: pointer;
    font-size: 12px;
  }
}
</style>
